import { forwardRef } from 'react'
import Link from 'next/link'

const CustomLink = forwardRef(({ ...props }, ref) => {
    return (
        <Link href={props.url} className={props.className || ''}>
            <a
                onClick={props.onClick}
                onMouseLeave={props.onMouseLeave}
                onMouseEnter={props.onMouseEnter}
                style={props.style}
                ref={ref}
                className={`cursorPointer ${props.className || ''}`}
                aria-label={'oplos'}
            >
                {props.content ?? props.children}
            </a>
        </Link>
    )
})

export default CustomLink
